/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * DCA-Pal APIs
 * OpenAPI spec version: 0.9.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  Asset,
  GetAssetsChartParams,
  GetAssetsDataParams,
  GetPriceParams,
  ImportPortfolioBody,
  ImportPortfolioResponse,
  Price,
  SyncPortfoliosRequest,
  SyncPortfoliosResponse,
  YahooChartResponse,
  YahooSearchResponse
} from './model';

import { apiFetch } from '../mutator/api-fetch';
type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type rootResponse200 = {
  data: string
  status: 200
}

export type rootResponseSuccess = (rootResponse200) & {
  headers: Headers;
};
;

export const getRootUrl = () => {




  return `/`
}

/**
 * @summary Returns the service greeting used by the root health-style endpoint.
 */
export const root = async ( options?: Parameters<typeof apiFetch>[1]): Promise<rootResponseSuccess> => {

  return apiFetch<rootResponseSuccess>(getRootUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getRootQueryKey = () => {
    return [
    `/`
    ] as const;
    }


export const getRootQueryOptions = <TData = Awaited<ReturnType<typeof root>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof root>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRootQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof root>>> = ({ signal }) => root({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof root>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RootQueryResult = NonNullable<Awaited<ReturnType<typeof root>>>
export type RootQueryError = unknown


export function useRoot<TData = Awaited<ReturnType<typeof root>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof root>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof root>>,
          TError,
          Awaited<ReturnType<typeof root>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRoot<TData = Awaited<ReturnType<typeof root>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof root>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof root>>,
          TError,
          Awaited<ReturnType<typeof root>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRoot<TData = Awaited<ReturnType<typeof root>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof root>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns the service greeting used by the root health-style endpoint.
 */

export function useRoot<TData = Awaited<ReturnType<typeof root>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof root>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRootQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type getAssetsChartResponse200 = {
  data: YahooChartResponse
  status: 200
}

export type getAssetsChartResponseSuccess = (getAssetsChartResponse200) & {
  headers: Headers;
};
;

export const getGetAssetsChartUrl = (symbol: string,
    params: GetAssetsChartParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/assets/chart/${symbol}?${stringifiedParams}` : `/assets/chart/${symbol}`
}

/**
 * @summary Proxies a historical chart request to the configured market-data provider.
 */
export const getAssetsChart = async (symbol: string,
    params: GetAssetsChartParams, options?: Parameters<typeof apiFetch>[1]): Promise<getAssetsChartResponseSuccess> => {

  return apiFetch<getAssetsChartResponseSuccess>(getGetAssetsChartUrl(symbol,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAssetsChartQueryKey = (symbol: string,
    params?: GetAssetsChartParams,) => {
    return [
    `/assets/chart/${symbol}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAssetsChartQueryOptions = <TData = Awaited<ReturnType<typeof getAssetsChart>>, TError = unknown>(symbol: string,
    params: GetAssetsChartParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssetsChart>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAssetsChartQueryKey(symbol,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAssetsChart>>> = ({ signal }) => getAssetsChart(symbol,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: symbol !== null && symbol !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAssetsChart>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAssetsChartQueryResult = NonNullable<Awaited<ReturnType<typeof getAssetsChart>>>
export type GetAssetsChartQueryError = unknown


export function useGetAssetsChart<TData = Awaited<ReturnType<typeof getAssetsChart>>, TError = unknown>(
 symbol: string,
    params: GetAssetsChartParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssetsChart>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssetsChart>>,
          TError,
          Awaited<ReturnType<typeof getAssetsChart>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAssetsChart<TData = Awaited<ReturnType<typeof getAssetsChart>>, TError = unknown>(
 symbol: string,
    params: GetAssetsChartParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssetsChart>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssetsChart>>,
          TError,
          Awaited<ReturnType<typeof getAssetsChart>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAssetsChart<TData = Awaited<ReturnType<typeof getAssetsChart>>, TError = unknown>(
 symbol: string,
    params: GetAssetsChartParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssetsChart>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Proxies a historical chart request to the configured market-data provider.
 */

export function useGetAssetsChart<TData = Awaited<ReturnType<typeof getAssetsChart>>, TError = unknown>(
 symbol: string,
    params: GetAssetsChartParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssetsChart>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAssetsChartQueryOptions(symbol,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type getAssetsCryptoResponse200 = {
  data: Asset[]
  status: 200
}

export type getAssetsCryptoResponseSuccess = (getAssetsCryptoResponse200) & {
  headers: Headers;
};
;

export const getGetAssetsCryptoUrl = () => {




  return `/assets/crypto`
}

/**
 * @summary Returns the cached cryptocurrency asset catalog.
 */
export const getAssetsCrypto = async ( options?: Parameters<typeof apiFetch>[1]): Promise<getAssetsCryptoResponseSuccess> => {

  return apiFetch<getAssetsCryptoResponseSuccess>(getGetAssetsCryptoUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAssetsCryptoQueryKey = () => {
    return [
    `/assets/crypto`
    ] as const;
    }


export const getGetAssetsCryptoQueryOptions = <TData = Awaited<ReturnType<typeof getAssetsCrypto>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssetsCrypto>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAssetsCryptoQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAssetsCrypto>>> = ({ signal }) => getAssetsCrypto({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAssetsCrypto>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAssetsCryptoQueryResult = NonNullable<Awaited<ReturnType<typeof getAssetsCrypto>>>
export type GetAssetsCryptoQueryError = unknown


export function useGetAssetsCrypto<TData = Awaited<ReturnType<typeof getAssetsCrypto>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssetsCrypto>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssetsCrypto>>,
          TError,
          Awaited<ReturnType<typeof getAssetsCrypto>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAssetsCrypto<TData = Awaited<ReturnType<typeof getAssetsCrypto>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssetsCrypto>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssetsCrypto>>,
          TError,
          Awaited<ReturnType<typeof getAssetsCrypto>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAssetsCrypto<TData = Awaited<ReturnType<typeof getAssetsCrypto>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssetsCrypto>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns the cached cryptocurrency asset catalog.
 */

export function useGetAssetsCrypto<TData = Awaited<ReturnType<typeof getAssetsCrypto>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssetsCrypto>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAssetsCryptoQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type getAssetsFiatResponse200 = {
  data: Asset[]
  status: 200
}

export type getAssetsFiatResponseSuccess = (getAssetsFiatResponse200) & {
  headers: Headers;
};
;

export const getGetAssetsFiatUrl = () => {




  return `/assets/fiat`
}

/**
 * @summary Returns the cached fiat asset catalog.
 */
export const getAssetsFiat = async ( options?: Parameters<typeof apiFetch>[1]): Promise<getAssetsFiatResponseSuccess> => {

  return apiFetch<getAssetsFiatResponseSuccess>(getGetAssetsFiatUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAssetsFiatQueryKey = () => {
    return [
    `/assets/fiat`
    ] as const;
    }


export const getGetAssetsFiatQueryOptions = <TData = Awaited<ReturnType<typeof getAssetsFiat>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssetsFiat>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAssetsFiatQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAssetsFiat>>> = ({ signal }) => getAssetsFiat({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAssetsFiat>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAssetsFiatQueryResult = NonNullable<Awaited<ReturnType<typeof getAssetsFiat>>>
export type GetAssetsFiatQueryError = unknown


export function useGetAssetsFiat<TData = Awaited<ReturnType<typeof getAssetsFiat>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssetsFiat>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssetsFiat>>,
          TError,
          Awaited<ReturnType<typeof getAssetsFiat>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAssetsFiat<TData = Awaited<ReturnType<typeof getAssetsFiat>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssetsFiat>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssetsFiat>>,
          TError,
          Awaited<ReturnType<typeof getAssetsFiat>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAssetsFiat<TData = Awaited<ReturnType<typeof getAssetsFiat>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssetsFiat>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns the cached fiat asset catalog.
 */

export function useGetAssetsFiat<TData = Awaited<ReturnType<typeof getAssetsFiat>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssetsFiat>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAssetsFiatQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type getAssetsDataResponse200 = {
  data: YahooSearchResponse
  status: 200
}

export type getAssetsDataResponseSuccess = (getAssetsDataResponse200) & {
  headers: Headers;
};
;

export const getGetAssetsDataUrl = (params: GetAssetsDataParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/assets/search?${stringifiedParams}` : `/assets/search`
}

/**
 * @summary Proxies an asset-name search to the configured market-data provider.
 */
export const getAssetsData = async (params: GetAssetsDataParams, options?: Parameters<typeof apiFetch>[1]): Promise<getAssetsDataResponseSuccess> => {

  return apiFetch<getAssetsDataResponseSuccess>(getGetAssetsDataUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAssetsDataQueryKey = (params?: GetAssetsDataParams,) => {
    return [
    `/assets/search`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAssetsDataQueryOptions = <TData = Awaited<ReturnType<typeof getAssetsData>>, TError = unknown>(params: GetAssetsDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssetsData>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAssetsDataQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAssetsData>>> = ({ signal }) => getAssetsData(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAssetsData>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAssetsDataQueryResult = NonNullable<Awaited<ReturnType<typeof getAssetsData>>>
export type GetAssetsDataQueryError = unknown


export function useGetAssetsData<TData = Awaited<ReturnType<typeof getAssetsData>>, TError = unknown>(
 params: GetAssetsDataParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssetsData>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssetsData>>,
          TError,
          Awaited<ReturnType<typeof getAssetsData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAssetsData<TData = Awaited<ReturnType<typeof getAssetsData>>, TError = unknown>(
 params: GetAssetsDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssetsData>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssetsData>>,
          TError,
          Awaited<ReturnType<typeof getAssetsData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAssetsData<TData = Awaited<ReturnType<typeof getAssetsData>>, TError = unknown>(
 params: GetAssetsDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssetsData>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Proxies an asset-name search to the configured market-data provider.
 */

export function useGetAssetsData<TData = Awaited<ReturnType<typeof getAssetsData>>, TError = unknown>(
 params: GetAssetsDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssetsData>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAssetsDataQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type importPortfolioResponse201 = {
  data: ImportPortfolioResponse
  status: 201
}

export type importPortfolioResponse400 = {
  data: void
  status: 400
}

export type importPortfolioResponseSuccess = (importPortfolioResponse201) & {
  headers: Headers;
};
export type importPortfolioResponseError = (importPortfolioResponse400) & {
  headers: Headers;
};

export const getImportPortfolioUrl = () => {




  return `/import/portfolio`
}

/**
 * @summary Validates and stores a shared portfolio payload.
 */
export const importPortfolio = async (importPortfolioBody: ImportPortfolioBody, options?: Parameters<typeof apiFetch>[1]): Promise<importPortfolioResponseSuccess> => {

  return apiFetch<importPortfolioResponseSuccess>(getImportPortfolioUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(importPortfolioBody)
  }
);}





export const getImportPortfolioMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importPortfolio>>, TError,{data: ImportPortfolioBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof importPortfolio>>, TError,{data: ImportPortfolioBody}, TContext> => {

const mutationKey = ['importPortfolio'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importPortfolio>>, {data: ImportPortfolioBody}> = (props) => {
          const {data} = props ?? {};

          return  importPortfolio(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImportPortfolioMutationResult = NonNullable<Awaited<ReturnType<typeof importPortfolio>>>
    export type ImportPortfolioMutationBody = ImportPortfolioBody
    export type ImportPortfolioMutationError = void

    /**
 * @summary Validates and stores a shared portfolio payload.
 */
export const useImportPortfolio = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importPortfolio>>, TError,{data: ImportPortfolioBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof importPortfolio>>,
        TError,
        {data: ImportPortfolioBody},
        TContext
      > => {
      return useMutation(getImportPortfolioMutationOptions(options), queryClient);
    }

export type getImportedPortfolioResponse200 = {
  data: unknown
  status: 200
}

export type getImportedPortfolioResponse404 = {
  data: void
  status: 404
}

export type getImportedPortfolioResponseSuccess = (getImportedPortfolioResponse200) & {
  headers: Headers;
};
export type getImportedPortfolioResponseError = (getImportedPortfolioResponse404) & {
  headers: Headers;
};

export const getGetImportedPortfolioUrl = (id: string,) => {




  return `/import/portfolio/${id}`
}

/**
 * @summary Returns a stored shared portfolio or a not-found response when it expired.
 */
export const getImportedPortfolio = async (id: string, options?: Parameters<typeof apiFetch>[1]): Promise<getImportedPortfolioResponseSuccess> => {

  return apiFetch<getImportedPortfolioResponseSuccess>(getGetImportedPortfolioUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetImportedPortfolioQueryKey = (id: string,) => {
    return [
    `/import/portfolio/${id}`
    ] as const;
    }


export const getGetImportedPortfolioQueryOptions = <TData = Awaited<ReturnType<typeof getImportedPortfolio>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImportedPortfolio>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetImportedPortfolioQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getImportedPortfolio>>> = ({ signal }) => getImportedPortfolio(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getImportedPortfolio>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetImportedPortfolioQueryResult = NonNullable<Awaited<ReturnType<typeof getImportedPortfolio>>>
export type GetImportedPortfolioQueryError = void


export function useGetImportedPortfolio<TData = Awaited<ReturnType<typeof getImportedPortfolio>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImportedPortfolio>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getImportedPortfolio>>,
          TError,
          Awaited<ReturnType<typeof getImportedPortfolio>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetImportedPortfolio<TData = Awaited<ReturnType<typeof getImportedPortfolio>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImportedPortfolio>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getImportedPortfolio>>,
          TError,
          Awaited<ReturnType<typeof getImportedPortfolio>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetImportedPortfolio<TData = Awaited<ReturnType<typeof getImportedPortfolio>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImportedPortfolio>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns a stored shared portfolio or a not-found response when it expired.
 */

export function useGetImportedPortfolio<TData = Awaited<ReturnType<typeof getImportedPortfolio>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImportedPortfolio>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetImportedPortfolioQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type getPriceResponse200 = {
  data: Price
  status: 200
}

export type getPriceResponse404 = {
  data: void
  status: 404
}

export type getPriceResponseSuccess = (getPriceResponse200) & {
  headers: Headers;
};
export type getPriceResponseError = (getPriceResponse404) & {
  headers: Headers;
};

export const getGetPriceUrl = (asset: string,
    params: GetPriceParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/price/${asset}?${stringifiedParams}` : `/price/${asset}`
}

/**
 * @summary Returns the current conversion price for a base asset and quote currency.
 */
export const getPrice = async (asset: string,
    params: GetPriceParams, options?: Parameters<typeof apiFetch>[1]): Promise<getPriceResponseSuccess> => {

  return apiFetch<getPriceResponseSuccess>(getGetPriceUrl(asset,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPriceQueryKey = (asset: string,
    params?: GetPriceParams,) => {
    return [
    `/price/${asset}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPriceQueryOptions = <TData = Awaited<ReturnType<typeof getPrice>>, TError = void>(asset: string,
    params: GetPriceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPrice>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPriceQueryKey(asset,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPrice>>> = ({ signal }) => getPrice(asset,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: asset !== null && asset !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPrice>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPriceQueryResult = NonNullable<Awaited<ReturnType<typeof getPrice>>>
export type GetPriceQueryError = void


export function useGetPrice<TData = Awaited<ReturnType<typeof getPrice>>, TError = void>(
 asset: string,
    params: GetPriceParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPrice>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPrice>>,
          TError,
          Awaited<ReturnType<typeof getPrice>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPrice<TData = Awaited<ReturnType<typeof getPrice>>, TError = void>(
 asset: string,
    params: GetPriceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPrice>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPrice>>,
          TError,
          Awaited<ReturnType<typeof getPrice>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPrice<TData = Awaited<ReturnType<typeof getPrice>>, TError = void>(
 asset: string,
    params: GetPriceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPrice>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns the current conversion price for a base asset and quote currency.
 */

export function useGetPrice<TData = Awaited<ReturnType<typeof getPrice>>, TError = void>(
 asset: string,
    params: GetPriceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPrice>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPriceQueryOptions(asset,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type syncPortfoliosResponse200 = {
  data: SyncPortfoliosResponse
  status: 200
}

export type syncPortfoliosResponse400 = {
  data: void
  status: 400
}

export type syncPortfoliosResponseSuccess = (syncPortfoliosResponse200) & {
  headers: Headers;
};
export type syncPortfoliosResponseError = (syncPortfoliosResponse400) & {
  headers: Headers;
};

export const getSyncPortfoliosUrl = () => {




  return `/v1/sync/portfolios`
}

/**
 * @summary Applies authenticated local portfolio changes and returns the server state.
 */
export const syncPortfolios = async (syncPortfoliosRequest: SyncPortfoliosRequest, options?: Parameters<typeof apiFetch>[1]): Promise<syncPortfoliosResponseSuccess> => {

  return apiFetch<syncPortfoliosResponseSuccess>(getSyncPortfoliosUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(syncPortfoliosRequest)
  }
);}





export const getSyncPortfoliosMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncPortfolios>>, TError,{data: SyncPortfoliosRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof syncPortfolios>>, TError,{data: SyncPortfoliosRequest}, TContext> => {

const mutationKey = ['syncPortfolios'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof syncPortfolios>>, {data: SyncPortfoliosRequest}> = (props) => {
          const {data} = props ?? {};

          return  syncPortfolios(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SyncPortfoliosMutationResult = NonNullable<Awaited<ReturnType<typeof syncPortfolios>>>
    export type SyncPortfoliosMutationBody = SyncPortfoliosRequest
    export type SyncPortfoliosMutationError = void

    /**
 * @summary Applies authenticated local portfolio changes and returns the server state.
 */
export const useSyncPortfolios = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncPortfolios>>, TError,{data: SyncPortfoliosRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof syncPortfolios>>,
        TError,
        {data: SyncPortfoliosRequest},
        TContext
      > => {
      return useMutation(getSyncPortfoliosMutationOptions(options), queryClient);
    }
